import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'

export const useMoteRecordPauseMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/m/pause',
    method: 'POST'
  })
}
